import { render } from "./BranchView.vue?vue&type=template&id=340189d9&scoped=true&ts=true"
import script from "./BranchView.vue?vue&type=script&lang=ts"
export * from "./BranchView.vue?vue&type=script&lang=ts"

import "./BranchView.vue?vue&type=style&index=0&id=340189d9&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340189d9"]])

export default __exports__